import { render, staticRenderFns } from "./module1.vue?vue&type=template&id=b23a1e92&scoped=true"
import script from "./module1.vue?vue&type=script&lang=js"
export * from "./module1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a1e92",
  null
  
)

export default component.exports